import type React from "react";
import { useMemo } from "react";

import { NO_DATA_SIGN } from "app/filters/const";
import { translate } from "app/filters/i18nFilter";

import type { SearchTrafficData } from "../../types";
import MetricTitle from "../MetricTitle/MetricTitle";

import { BodyContainer, FooterContainer, Container } from "./styledComponents";
import { SearchOverviewTexts } from "../../../../texts";

const CompoundWidget = ({ children }: { children: React.ReactNode }) => {
    return <Container>{children}</Container>;
};

const Body = ({
    data,
    descriptionText,
    granularityText = translate(SearchOverviewTexts.yoy),
    children,
}: {
    data: SearchTrafficData;
    descriptionText: string;
    granularityText?: string;
    children?: React.ReactNode;
}) => {
    const formattedMetricTitle = useMemo(() => (data?.title ? data.title : NO_DATA_SIGN), [data?.title]);
    return (
        <BodyContainer>
            <MetricTitle
                granularityText={granularityText}
                title={formattedMetricTitle}
                data={data}
                descriptionText={descriptionText}
            />
            {children}
        </BodyContainer>
    );
};

const Footer = ({ children }: { children: React.ReactNode }) => {
    return <FooterContainer>{children}</FooterContainer>;
};
CompoundWidget.Body = Body;
CompoundWidget.Footer = Footer;

export default CompoundWidget;
